var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronBottom = function SvgChevronBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 9 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5 5.27c.226 0 .413-.079.596-.27l3.2-3.27a.68.68 0 0 0 .204-.5.727.727 0 0 0-.722-.73.73.73 0 0 0-.535.235L4.496 3.57 1.756.735A.75.75 0 0 0 1.223.5a.727.727 0 0 0-.518 1.23L3.904 5c.183.187.366.27.596.27"
  })));
};
export default SvgChevronBottom;